import React from 'react';
import PropTypes from 'prop-types';

import { Helmet } from 'polaris-coreweb/exports';
import { withPolaris } from 'Components/protons/Polaris';

import { Accordion } from 'Components/organisms/Accordion';

import './_style.scss';

export const FAQsId = 'FAQsAccordion';

const FAQs = (props) => {
  const {
    context: {
      cssPrefix,
    },
    data,
    title: faqsTitle,
    iconClose,
    iconOpen,
  } = props;

  // Translate data from 'question/answer' to 'title/content'
  const convertQuestionAndAnswerToTitleAndContent = qandas => qandas.map(({ question, answer }) => ({
    title: question,
    content: answer,
  }));

  // structured data
  const jsonld = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: data && Array.isArray(data) && data.map(({ question, answer }) => ({
      '@type': 'Question',
      name: question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: answer,
      },
    })),
  };

  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(jsonld)}</script>
      </Helmet>
      <div className={`${cssPrefix}__faqs-section`}>
        <div className={`${cssPrefix}__faqs-section--title`}>{faqsTitle}</div>
        <div className={`${cssPrefix}__content`}>
          {
            Array.isArray(data)
            && data.length !== 0
            && (
              <Accordion
                items={convertQuestionAndAnswerToTitleAndContent(data)}
                exclusive={false}
                iconClose={iconClose}
                iconOpen={iconOpen}
              />
            )
          }
        </div>
      </div>
    </>
  );
};

FAQs.propTypes = {
  context: PropTypes.shape({
    cssPrefix: PropTypes.string,
  }),
  data: PropTypes.oneOfType([PropTypes.array, PropTypes.shape()]),
  title: PropTypes.string,
  iconClose: PropTypes.string,
  iconOpen: PropTypes.string,
};

FAQs.defaultProps = {
  context: {
    cssPrefix: 'polaris',
  },
  data: [],
  title: '',
  iconClose: '',
  iconOpen: '',
};

export default withPolaris(FAQs);
